import {
  pitchPlanStatus,
  pitchPlanStatusDescription,
  pitchPlanStatusLabel,
  type PitchPlanStatus,
} from "@/lib/pitchAssignment";
import type { Booking } from "@/types/camping";

const STATUS_STYLES: Record<PitchPlanStatus, string> = {
  fixed: "bg-status-green/15 text-status-green border-status-green/30",
  suggested: "bg-status-orange/15 text-status-orange border-status-orange/30",
  occupied: "bg-status-red/15 text-status-red border-status-red/30",
  open: "bg-fill-tertiary text-label-secondary border-separator",
};

export interface PitchPlanBadgeProps {
  booking: Pick<Booking, "pitch_id" | "pitch_assignment_mode" | "status">;
  className?: string;
}

export function PitchPlanBadge({ booking, className = "" }: PitchPlanBadgeProps) {
  const status = pitchPlanStatus(booking);
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium leading-tight ${STATUS_STYLES[status]} ${className}`}
      title={pitchPlanStatusDescription(status)}
    >
      {pitchPlanStatusLabel(status)}
    </span>
  );
}
